import Indicadores from "./indicadores/Indicadores";
import {Checkbox} from "primereact/checkbox";
import {
    MostrarRutaIcon, SeguirEnMapaIcon,
    SeparadorPuntoIcon
} from "../../../icons/SeguimientoYMonitoreo/SeguimientoIcons";
import React from "react";
import {colorIndicadores, tipoIndicador} from "./SeguimentoConstantes";
import { ReactComponent as WrenchSvg } from '../../../icons/wrench-solid.svg';
import  { ReactComponent as OperadorSvg } from '../../../icons/nuevoIngreso.svg';
import constantes from "../../constantes";

const TarjetaViaje = React.memo( ({
                                      viajeId, unidadId,unidad, cajaId, caja, subCliente, cliente, ruta, cartaPorte, color,esExpeditado, operador, indicadores,
                                      onTooltipIndicador, onHideTooltip, soloUnidades,getBotonPanicoCss,getAlertaPenskeCss,getAlertaRescateCss,getAlertaConduccionCss,
                                      mostrarOcultar, viajeVisible,centrarUnidad, esSeguimientoMonitoreo, seleccionarViaje,
                                      overlayOnClick, viajeRutaId, tieneMantenimiento,nuevoIngreso, estatus
}) => {


    const onUnidadClick = (e,unidadId)=>{
        centrarUnidad(unidadId)
        e.stopPropagation()
    }

    return (
     <div className={`seg-viaje-tarjeta ${getBotonPanicoCss(viajeId)} ${getAlertaPenskeCss(viajeId)} ${getAlertaRescateCss(viajeId)} ${getAlertaConduccionCss(viajeId)}`}>



       {/* </div><div className={`seg-viaje-tarjeta ${getBotonPanicoCss(viajeId)}`}> */}
            <div className={'seg-seleccionar'}>
                <Checkbox inputId="seleccionar" checked={viajeVisible(viajeId)}
                          onChange={() => mostrarOcultar(viajeId)}/>
            </div>
            <div className={'seg-viaje'} onClick={() => seleccionarViaje(viajeId)}>
                <div className={'seg-unidad'}>
                    <span onClick={(e)=>onUnidadClick(e, unidadId)}>{unidad}</span>
                    <SeparadorPuntoIcon/>
                    <span onClick={(e)=>onUnidadClick(e, cajaId)}>{caja}</span>
                    <SeparadorPuntoIcon/>
                    <span className={'seg-operador'}>{operador}</span>
                    <div className={'seg-actions'}>
                        <span className={`${viajeRutaId === viajeId ? 'seleccionado' : '' }`}
                            onClick={(e) => overlayOnClick(e, tipoIndicador.showRoute, viajeId)}>
                            <MostrarRutaIcon/>
                        </span>
                        <span onClick={(e) => overlayOnClick(e, tipoIndicador.followInMap, viajeId)}>
                            <SeguirEnMapaIcon/>
                        </span>
                    </div>
                </div>
                <div style={{display: 'flex', gap: '5px', position:'relative'}}>
                    <div className={'seg-cliente'} style={{maxWidth: subCliente ? '185px' : '320px'}}>
                        {cliente}
                    </div>
                    {subCliente &&
                        <>
                            <span>/</span>
                            <div className={'seg-cliente'} style={{maxWidth: '130px'}}>
                                {subCliente}
                            </div>
                        </>
                    }
                    <span className={'seg-expeditado'}>
                        {esExpeditado ? 'Exp' : ''}
                    </span>
                    {tieneMantenimiento &&
                     <span className="seg-mantenimiento" style={{ float: 'right' }}>
                         <WrenchSvg style={{ height: 15, width: 15, fill: "#FFCC0F" }} />
                    </span>
                    }
                  {nuevoIngreso && (
                        <span className="seg-nuevo" title="Operador de nuevo ingreso" style={{ float: 'right' }}>
                            <OperadorSvg style={{ height: 20, width: 20, fill: "#FC4B08" }} />
                        </span>
                    )}

                </div>
                <span className={'seg-ruta'}>
                    {ruta} <span className={'seg-carta-porte'}>({cartaPorte})</span>
                    <span className={'bold'}> {estatus === constantes.estatusViajes.programado ? 'programado' : 'en ruta'}</span>
                </span>
                <div className={'seg-indicadores'}>
                    <Indicadores viajeId={viajeId} indicadores={indicadores} onMouseEnter={onTooltipIndicador} onMouseLeave={onHideTooltip}
                                 onClick={overlayOnClick} soloUnidades={soloUnidades} esSeguimientoMonitoreo={esSeguimientoMonitoreo}/>
                </div>
            </div>
            <div className={`seg-alerta ${colorIndicadores[color]}`} >
                <div className={'estatus-alerta'}>

                </div>
            </div>
        </div>
    )
})

export default TarjetaViaje;